















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import userx from '@/store/modules/userx';
import { OAuthSigninMethod, User } from '@/store/firestore';
import { EditState } from '@/store/models.def';
import { getCrazyGamesToken } from '@/store/sf-firestore';

@Component({
  components: {},
})
export default class CrazyGamesSignInButton extends Vue {
  @Prop({ default: false }) public disabled!: boolean;

  public async signIn() {
    this.$emit('sending');
    try {
      const token = await getCrazyGamesToken();
      if (token) {
        const result = await userx.signInWithCrazyGames(token);
        this.$emit('done');
      } else {
        this.$emit('active');
      }
    } catch (error) {
      this.$root.$emit('error', error);
      this.$emit('active');
    }
  }
}
